import { Divider, Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../../ConfigFields/Duration';
import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const DocumentMetadataVariant = {
  schema: PatientDataStore.DocumentMetadataConfigSchema,
  Config: () => {
    const { setValue: setEncounters } = useSelectedNodeField('config.encounters');
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Document Metadata Filters
        </Text>
        <ParentBlockSelectField
          fieldName="config.encounters.sourceBlockName"
          label="Encounters Source"
          helperText={getSourceBlockNameHelperText('encounters')}
          clearable
          onClear={() => setEncounters(undefined)}
        />
        <BlockValueTemplateField
          fieldName="config.documentMetadataFilters.documentTitle"
          label="Document Title"
          required={false}
          helperText="e.g. {{document.data.title}} or Progress Notes"
        />
        <BlockValueTemplateField
          fieldName="config.documentMetadataFilters.documentType"
          label="Document Type"
          required={false}
          helperText="e.g. {{document.data.type}} or Referral Letter"
        />
        <BlockDurationField
          fieldName="config.documentMetadataFilters.lookbackDuration"
          toggleLabel="Filter by Document Metadata date"
          valueLabel="Only fetch document metadata within last"
          unitFieldNameSuffix="units"
          required={false}
          allowedUnits={[...PatientDataStore.DURATION_UNIT_OPTIONS]}
        />
        <Divider sx={{ marginY: 2 }} />
        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
